import { Cirus } from "@/classes/Http";
import { InvoiceType } from "./PublishBoughtInvoice.command";

enum TransactionUserType {
    CUSTOMER = "0",
    USER = "1"
}

class InvoiceTransaction {
    name: string;
    count: number;
    value: number;
    value_without_off: number = null;
    price_id: string;
    creator_type: TransactionUserType;
    creator_id: string;
    inventory_id: string = null;
    type: InvoiceType.BOUGHT = InvoiceType.BOUGHT;
}

class Payment {
    Amount = 0;
    paid = false;
}


export class PublishInstanceCostInvoiceBody {
    customer_id: string;
    title: string;
    description: string;
    type: InvoiceType.INCOME = InvoiceType.INCOME;
    transactions: InvoiceTransaction[];
    payment: Payment;
    draft = false;
    total = 0;
}

export function publishInstanceCostInvoice(instance_id: number, params: PublishInstanceCostInvoiceBody) {
    const path = `/instance/${instance_id}/invoice-cost/publish`;
    return Cirus.post(path, params);
}